import React, { useContext, useState, useEffect } from "react";
import SidePanel from "../side-panel";
import * as styles from "./styles.mod.scss";
import locale from "locales";
import GlobalContext from "services/global-context";
import { Formik } from "formik";
import TextInput from "../text-input";
import * as Yup from "yup";
import { createCustomerAccessToken, setCustomerAccessToken } from "services/shopify-account";
import { navigate } from "@reach/router";
import Show from "assets/images/icons/show.svg";
import Hide from "assets/images/icons/hide.svg";
import { trackError, trackLogin, trackEmailAddress } from "helpers/analytics";
import hashEmailAddress from "helpers/hash-email-address";

const LoginSchema = Yup.object().shape({
  email: Yup.string().email().required(locale.login.invalidEmail),
  password: Yup.string().required(locale.login.enterPsw)
});

const Login = ({ wasOpened }) => {
  const [opened, setOpened] = useState(false);
  const [closing, setClosing] = useState(false);
  const { setCurrentPanel, getCustomerProfile } = useContext(GlobalContext);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const showPass = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = ({ email, password }, { setFieldError }) => {
    setSubmitDisabled(true);

    createCustomerAccessToken({
      email, password
    }).then((response) => {
      setSubmitDisabled(false);
      if (response.data.customerAccessTokenCreate?.customerUserErrors?.length > 0) {
        const unknownCustomer = response.data.customerAccessTokenCreate.customerUserErrors.find(k => k.code === "UNIDENTIFIED_CUSTOMER");

        if (unknownCustomer) {
          setFieldError("email", locale.login.unknownCustomer);
          trackError(locale.login.unknownCustomer);
        }
      } else if (response.data.customerAccessTokenCreate?.customerAccessToken) {
        setCustomerAccessToken(response.data.customerAccessTokenCreate.customerAccessToken);
        getCustomerProfile(() => {
          navigate("/account/invite-friends");
        });
        trackLogin();
        trackEmailAddress(hashEmailAddress(email));
        setCurrentPanel(null);
        localStorage.setItem("isLoggedIn", "true");
      }
    });
  };

  const handleRegistration = () => {
    setCurrentPanel("registration"); return false;
  };

  const handleResetPassword = () => {
    setCurrentPanel("resetPassword"); return false;
  };

  useEffect(() => {
    setTimeout(() => !closing && setOpened(true), 0);
  });

  const handleClose = () => {
    setClosing(true);
    setOpened(false);
    setTimeout(() => setCurrentPanel(null), 250);
  };


  const isOpen = () => opened || (!closing && wasOpened);

  const trackLoginError = (formErrors) => {
    const errorMessages = Object.values(formErrors).join("; ");
    if (errorMessages) {
      trackError(errorMessages);
    }
  };

  return <SidePanel
    open={true}
    className={`${styles.sidePanel} ${isOpen() ? styles.opened : ""}`}
    bodyClass={styles.body}
    onClose={handleClose}
  >
    <h3>{locale.login.title}</h3>
    <p>{locale.login.subtitle}</p>
    <Formik
      initialValues={{
        email: "", password: ""
      }}
      onSubmit={handleSubmit}
      validationSchema={LoginSchema}
    >
      {
        ({ errors, touched, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className={styles.formInner}>
              <div className="row">
                <div className="col-12">
                  <TextInput type="text" name="email" onChange={handleChange} placeholder={locale.login.email} errors={errors.email} touched={touched.email} />
                </div>
                <div className="col-12">
                  <div className={styles.showPasswordIcon}>
                    <TextInput name="password" type={showPassword ? "text" : "password"} onChange={handleChange} placeholder={locale.login.password} errors={errors.password} touched={touched.password} />
                    <p onClick={showPass}>{showPassword ? <img src={Show} alt={locale.altText.showPassword} /> : <img src={Hide} alt={locale.altText.hidePassword} />}</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <p className={styles.links}>
                    {locale.login.noAccount} <a href="#" onClick={handleRegistration}>{locale.login.register}</a> <br /><br />
                    <a href="#" onClick={handleResetPassword}>{locale.login.forgotPsw}</a>
                  </p>
                </div>
              </div>
            </div>
            <button type="submit" disabled={submitDisabled} className={styles.button}  onClick={() => trackLoginError(errors)}>{locale.login.login}</button>
          </form>
        )
      }

    </Formik>
  </SidePanel>;
};

export default Login;
